import { LoginCta, PrimaryLink } from "./NudgeShared";
import CompressChevron from "assets/chevron-down.svg";
import styles from "./NudgeExpanded.module.scss";
import sharedStyles from "./NudgeShared.module.scss";
import cx from "classnames";

type NudgeProps = {
  title: string;
  subtitle: string;
  count: number;
  pageViews: number;
  lastArticle: boolean;
  countText: string;
  setShowExpanded: (showExpanded: boolean) => void;
  setSlidingDirection: (slidingDirection: string) => void;
};

const NudgeExpanded = ({
  title,
  subtitle,
  count,
  pageViews,
  lastArticle,
  countText,
  setShowExpanded,
  setSlidingDirection,
}: NudgeProps) => {
  return (
    <div
      className={styles.root}
      id="nudgeExpanded"
      data-testid="nudge"
      data-category="nudge interaction"
      data-label="nudge-expanded"
    >
      <div className={styles.mobileCta}>
        {!lastArticle && (
          <span
            className={cx(
              styles.countMobile,
              "nudge-expanded__article-count-number--mobile"
            )}
          >
            {count}
          </span>
        )}
        <span
          className={cx(
            styles.countTextMobile,
            lastArticle && styles.emphasizedText,
            "nudge-expanded__article-count-text--mobile"
          )}
        >
          {countText}
        </span>
      </div>
      <div
        className={styles.cta}
        data-action="nudge:display"
        data-label="nudge-expanded"
      >
        {!lastArticle && (
          <span
            className={cx(
              styles.count,
              "nudge-expanded__article-count-number--desktop"
            )}
          >
            {count}
          </span>
        )}
        <span
          className={cx(
            styles.countText,
            lastArticle && styles.emphasizedText,
            "nudge-expanded__article-count-text--desktop"
          )}
        >
          {countText}
        </span>
        <LoginCta includeText={true} source="nudge-expanded" />
      </div>
      <div className={styles.text}>
        <h3 className={cx(styles.title, "nudge-expanded__title--desktop")}>
          {title}
        </h3>
        <h4
          className={cx(styles.subtitle, "nudge-expanded__subtitle--desktop")}
        >
          {subtitle}
        </h4>
      </div>
      <PrimaryLink
        text={"Subscribe Now"}
        source={"nudge-expanded"}
        count={pageViews}
        isExpandedStyles={true}
      />
      <button
        className={cx(sharedStyles.chevron, styles.chevronExpanded)}
        aria-label="Hide subscription information"
        aria-pressed="true"
        data-action="nudge:user_collapse"
        data-label="nudge-expanded"
        onClick={() => {
          setSlidingDirection("down");
          setTimeout(() => {
            setShowExpanded(false);
            setSlidingDirection("none");
          }, 100);
        }}
      >
        <CompressChevron focusable="false" />
      </button>
    </div>
  );
};

export default NudgeExpanded;
